<ng-container *ngIf="broadcastMessages$ | async as broadcasts">
    <button mat-icon-button class="broadcast-btn" aria-label="Show Messages" i18n-aria-label="topnav show messages@@topnav-show-messages"
            [matMenuTriggerFor]="menu" *ngIf="broadcasts && broadcasts.length > 0">
        <i i18n-title="topnav messages@@topnav-messages" title="Messages" class="fa fa-bullhorn fa-lg mr-1" aria-hidden="true"></i>
    </button>
</ng-container>

<mat-menu #menu="matMenu" role="menu"  [yPosition]="'below'" [xPosition]="'before'" [overlapTrigger]="'false'" class="broadcast-list mylaunch-content-mobile">
    <ng-template matMenuContent class="p-0">
        <div (keypress)="$event.stopPropagation();" (click)="$event.stopPropagation();">
            <app-broadcasts [showHideButton]="false" [broadcastMessages$]="broadcastMessages$" (clickOnEditBtnEvent)="closeMenu()"></app-broadcasts>
        </div>
    </ng-template>
</mat-menu>
